export default {
  banner: {
    title: 'Gator Protect',
    description: 'Powered by Monarx AI',
    selectPlanLabel: 'Confira a proteção da hospedagem para:',
    mainDomain: 'domínio principal:',
    proBadgeLabel: 'PRO',
    img: {
      alt: 'Snappy Monarx',
    },
  },
  summary: {
    title: 'Ameaças identificadas',
    maliciousCodesRemoved: 'Arquivos maliciosos',
    maliciousCodesRemovedDescription: 'Ative a proteção para eliminar essa ameaça.',
    compromisedFiles: 'Arquivos comprometidos',
    compromisedFilesDescription: 'Ative a proteção para eliminar essa ameaça.',
    keepProtected: 'Mantenha seu site protegido!',
    keepProtectedDescription: 'Não espere o período de teste da proteção completa acabar. Mantenha a proteção e fique tranquilo!',
    keepProtectionActive: 'Manter proteção ativa',
    protectionCard: {
      trialIsActive: {
        title: 'Proteção automática disponível',
        description: 'Ative agora para remover as ameaças identificadas automaticamente.',
        actions: [
          {
            key: 'activateProtectionPro',
            label: 'Ativar Proteção Pro',
            variant: 'primary',
          },
        ],
      },
      automaticProtectionAvailable: {
        title: 'Proteção automática disponível',
        description: 'Ative agora para remover as ameaças identificadas automaticamente.',
        activateProtectionPro: {
          key: 'activateProtectionPro',
          label: 'Ativar Proteção Pro',
          variant: 'secondary',
        },
        activateTrial: {
          regular: {
            key: 'activateTrial',
            label: 'Testar 30 dias grátis',
            variant: 'primary',
          },
          aa: {
            key: 'activateTrial',
            label: 'Testar 1 ano grátis',
            variant: 'primary',
          },
        },
      },
      safeWithoutInterruption: {
        title: 'Continue seguro sem interrupções.',
        description: 'Durante o período de teste, o Gator Protect Pro já protege seu site contra ameaças reais, de forma automática.',
        actions: [
          {
            key: 'keepProtectionActive',
            label: 'Manter proteção ativa',
            variant: 'primary',
          },
        ],
      },
    },
    protectionModal: {
      common: {
        productTitle: 'Gator Protect',
        productSubtitle: 'Powered by Monarx AI',
        proBadgeLabel: 'PRO',
        checklistItems: [
          'Remoção automática de ameaças',
          'Monitoramento contínuo do site',
          'Atendimento especializado',
          'Proteção ativa 24h',
        ],
      },
      trialActivation: {
        title: isAa => `Ative agora e não pague nada por ${isAa ? '1 ano' : '30 dias'}`,
        subtitle: price => `Após o período gratuito, assine por apenas ${price} por mês`,
        buttonLabel: 'Ativar teste gratuito',
      },
      trialActive: {
        title: 'Continue com a proteção completa ativa',
        subtitle: 'Após o período de teste, a remoção automática será desativada.',
        message: daysLeft => (daysLeft >= 0 ? `Seu teste encerra em ${daysLeft} dias.` : ''),
        buttonLabel: price => `Ativar agora por ${price}/mês`,
      },
      proActivation: {
        title: 'Proteção completa para seus projetos',
        subtitle: 'Garanta monitoramento contínuo e remoção automática de ameaças.',
        buttonLabel: price => `Ativar agora por ${price}/mês`,
      },
    },
    automaticCleaningConsentModal: {
      title: 'Confirme a limpeza automática',
      description: 'Autorizo a remoção dos arquivos infectados e estou ciente de que o processo pode causar perda de páginas ou impactar o funcionamento do site. Não responsabilizo o suporte da HostGator por este processo.',
      checkboxLabel: 'Li e aceito',
      cancelButtonLabel: 'Cancelar',
      confirmButtonLabel: 'Iniciar limpeza',
    },
    alerts: {
      fullProtectionActive: '<b>Proteção completa ativa.</b> Seu site sempre seguro!',
      automaticRemovalLabel: isActive => `Remoção automática de ameaças: <strong>${isActive ? 'ativa' : 'desativada'}</strong>`,
      automaticRemovalTooltip: 'Quando ativado, o sistema identifica e remove automaticamente ameaças no seu site.',
      cleaningInProgress: 'Sua limpeza está em andamento. Aguarde até 24h para realizar uma nova solicitação.',
      expiredProtection: 'A proteção do seu site acabou. Não deixe seu site vulnerável a ameaças.',
      trialActive: daysLeft => `<b>Seu período de teste ainda está ativo.</b> Seu site protegido por mais <b>${daysLeft} dias!</b>`,
      teamIntervention: {
        title: threatsNumber => `Você tem ${threatsNumber} ameaças que precisam de intervenção da nossa equipe!`,
        description: 'Para que a equipe continue a análise e o tratamento, é preciso abrir um chamado.',
        buttonLabel: 'Abrir chamado',
      },
      teamInterventionResolved: {
        title: 'A ameaça foi analisada e eliminada pela nossa equipe',
        description: 'Sua hospedagem continua protegida com monitoramento automático de novas ameaças.',
        buttonLabel: 'Acessar chamado',
      },
    },
  },
  activitiesChart: {
    title: 'Atividades detectadas',
    filter: {
      last30Days: 'Últimos 30 dias',
    },
    compromisedFilesLabel: 'Arquivos comprometidos',
    maliciousCodesLabel: 'Arquivos maliciosos',
    emptyTitle: 'Nenhuma atividade',
    emptyImageAlt: 'Nenhuma atividade',
    emptyDescription: 'Nenhuma ameaça identificada ou arquivos suspeitos nos últimos 30 dias.',
  },
  terms: {
    label: 'Li e aceito os ',
    cta: 'Termos e Condições',
  },
};
